import { SET_CANCEL_SOURCE, RESET_CANCEL_SOURCE } from "../types";

export default function apiCancelSource(state = {}, action = {}) {
  switch (action.type) {
    case SET_CANCEL_SOURCE: {
      return action.cancelToken;
    }
    case RESET_CANCEL_SOURCE: {
      return {};
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/apiCancelSource.js